// Lookups for the skills a person enters about themselves: their skill category, the sub-categories
// their experience is recorded under and the skills (`Skill`, each under one sub-category).
import { buildPagingLiteral, buildWhereLiteral } from '@/lib/graphql-query-builder';

export const buildGetSkillOptionsQuery = (
  where: Record<string, unknown>,
  pageNo: number,
  pageSize: number
) => `
  query {
    Skills: getSkills(
      where: ${buildWhereLiteral(where)}
      order: []
      paging: ${buildPagingLiteral(pageNo, pageSize)}
    ) {
      hasNextPage
      items {
        ItemId
        Name
        SubCategoryId
        LegacyKey
      }
    }
  }
`;

export const buildGetSkillSubCategoryOptionsQuery = (
  where: Record<string, unknown>,
  pageNo: number,
  pageSize: number
) => `
  query {
    SkillSubCategorys: getSkillSubCategorys(
      where: ${buildWhereLiteral(where)}
      order: []
      paging: ${buildPagingLiteral(pageNo, pageSize)}
    ) {
      totalCount
      items {
        ItemId
        Title
      }
    }
  }
`;

export const buildGetSkillCategoryOptionsQuery = (
  where: Record<string, unknown>,
  pageNo: number,
  pageSize: number
) => `
  query {
    SkillCategorys: getSkillCategorys(
      where: ${buildWhereLiteral(where)}
      order: []
      paging: ${buildPagingLiteral(pageNo, pageSize)}
    ) {
      totalCount
      items {
        ItemId
        Title
      }
    }
  }
`;
